/**
 * @file: useHelpVideos.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useServiceFactory } from '@euler/services/factory';
import { useAutoClearAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useHelpVideos = () => {
  const { supportService } = useServiceFactory();
  const fetch = useCallback(() => {
    return supportService.getHelpVideos();
  }, [supportService]);
  return useAutoClearAsyncResource(fetch, 'support:help-videos');
};
